import { useEffect } from 'react';
import { isLyrraOne } from '@/lib/platform';
import { LYRRAONE_LOGO_ICON_SRC } from '@/lib/lyrraone-brand';

/** Favicon LyrraOne au démarrage (build `VITE_PLATFORM_MODE=lyrraone`). */
export function LyrraOneBrandSync() {
  useEffect(() => {
    if (!isLyrraOne()) return;

    const link =
      document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
      (() => {
        const el = document.createElement('link');
        el.rel = 'icon';
        el.type = 'image/png';
        document.head.appendChild(el);
        return el;
      })();

    link.href = LYRRAONE_LOGO_ICON_SRC;
    link.type = 'image/png';
  }, []);

  return null;
}

export default LyrraOneBrandSync;
